import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

import '../../styles/use-case-tile.css';
import { ArrowButton } from '../generic/ArrowButton';

export interface UseCaseTileProps {
  /**
   * Use Case title
   */
  title: string;
  /**
   * Use Case description
   */
  description: string;
  /**
   * Use Case slug
   */
  slug?: string;
  /**
   * An optional link to navigate to after clicking the tile
   */
  link?: string;
  /**
   * Image src
   */
  image?: IGatsbyImageData;
  /**
   * Indicates if image is dark
   */
  isImageDark: boolean;
  /**
   * Indicates if image is loaded lazily
   */
  imageLoading?: 'lazy' | 'eager';
}

export const UseCaseTile = ({
  title,
  description,
  slug,
  link,
  image,
  isImageDark,
  imageLoading = 'lazy',
}: UseCaseTileProps) => {

  return (
    <div className={`use-case-tile ${isImageDark ? 'use-case-tile-dark' : ''}`}>
      <Link
        // @todo consider using just link prop
        to={link || `/use-cases/${slug}`}
        className="use-case-tile-link"
      >
        <div className="use-case-tile-content">
          <h2 className="use-case-tile-title">{title}</h2>
          <div className="use-case-tile-description">{description}</div>
          {(link || slug) && <ArrowButton />}
        </div>
        {!!image && (
          <GatsbyImage
            image={image}
            loading={imageLoading}
            objectFit="cover"
            objectPosition="80% bottom"
            // @todo add image alt text
            alt=""
          />
        )}
      </Link>
    </div>
  );
};
